import { render, staticRenderFns } from "./TakeBackDrawer.vue?vue&type=template&id=dc1c193e&scoped=true&lang=pug&"
import script from "./TakeBackDrawer.vue?vue&type=script&lang=js&"
export * from "./TakeBackDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TakeBackDrawer.vue?vue&type=style&index=0&id=dc1c193e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1c193e",
  null
  
)

/* custom blocks */
import block0 from "./TakeBackDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports